// extracted by mini-css-extract-plugin
export default {"memberSettings_page":"MemberSettings_memberSettings_page__2kvdM"};